import React, { useState, useEffect, useRef } from 'react'
import './bst.css'
import { motion } from 'framer-motion'
const firstVariant = {
    hidden: {
        y: "10vh",
        opacity: 0
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            delay: 0.3,
            duration: 1
        }
    }
}
const secondVariant = {
    hidden: {
        y: "10vh",
        opacity: 0
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            delay: .3,
            duration: 1
        }
    }
}
const buttonVariant = {
    hover: {
        opacity: '70%',
        scale: [1, 1.1, 1, 1.1, 1],
        transition: {
            delay: .2,
            duration: .3
        }
    }
}
export default function Bst() {
    const [isVisible, setIsVisible] = useState(false)
    const bstIntersectionRef = useRef([]);
    useEffect(() => {
        const observer = new IntersectionObserver((enteries) => {
            enteries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true)
                } else {
                    setIsVisible(false)
                }
            })
        }, {
            threshold: 0.5
        })
        bstIntersectionRef.current.forEach(bstIntersection => {
            if (bstIntersection) {
                observer.observe(bstIntersection)
            }
        })
    })
    return (
        <div className='bst-container'>
            <motion.div className="bst-text"
                variants={firstVariant}
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                ref={el => bstIntersectionRef.current[0] = el}>
                <h3>Buy, Sell & Trade</h3>
                <p>Our all-in-one platform offers seamless integration and management of your blockchain applications. Stay up with the latest news and trends in the crypto space.</p>
                <motion.button
                    variants={buttonVariant}
                    whileHover="hover">Explore Now</motion.button>
            </motion.div>
            <motion.div className="bst-image"
                variants={secondVariant}
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                ref={el => bstIntersectionRef.current[1] = el}>
                <img src="assets/bst/Crypto portfolio-rafiki.png" alt="" />
            </motion.div>
        </div>
    )
}
